/**
 * メインjs
 * ※jQueryはCDNで読み込んでいるのでimport不要。外部依存として解決済み
 */

import Init from './modules/init';
import Contact from './modules/contact';
import Slider from './modules/slider';
import Filter from './modules/filter';
import Header from './modules/header';
import Accordion from './modules/accordion';

import '../scss/style.scss'; // CSSが出力できなくなるので削除禁止

class App {
	constructor(){
		this.Init = new Init();
		this.Contact = new Contact();
		this.Slider = new Slider();
		this.Filter = new Filter();
		this.Header = new Header();
		this.Accordion = new Accordion();
	}
}

const app = new App();
